// Modelo Hoja de ruta.
export default class RouteSheet {
    id=""
    profile=""
    type=""
    description=""
    company={}
    procedure={}
    price=""
}


// WEBPACK FOOTER //
// ./src/model/RouteSheet.js